import { ListItemText } from '@mui/material'
import { MenuItem, SelectField, Typography } from '@carto/meridian-ds/components'
import { useAppSelector } from 'app/state'
import { getEnrichedDatasetById } from 'features/builder/state/keplerGlSlice'
import { FormattedMessage } from 'react-intl'
import { ANALYSIS_FIELDS_DENYLIST } from 'features/builder/ui/builderConstants'
import TypeTag from 'features/common/ui/TypeTag'

function ColumnsDropdown({
  source,
  placeholderId = 'analysis.addColumn.secondColumnPlaceholder',
  column,
  labelId,
  supportedColumnsTypes,
  isDisabled = false,
  isOptional = false,
  excludeGeom = false,
  onChange
}: {
  source: string
  placeholderId?: string
  column: string
  labelId?: string
  supportedColumnsTypes?: string[]
  isDisabled?: boolean
  isOptional?: boolean
  excludeGeom?: boolean
  onChange: (column: string, type?: string) => void
}) {
  const sourceColumns = useAppSelector((state) => getEnrichedDatasetById(state, source as string))?.metadata.schema
  let filteredColumns = supportedColumnsTypes?.length
    ? sourceColumns?.filter((field) => supportedColumnsTypes.includes(field.type))
    : sourceColumns

  filteredColumns = filteredColumns.filter((field) => !ANALYSIS_FIELDS_DENYLIST.has(field.name))

  if (excludeGeom) {
    filteredColumns = filteredColumns?.filter((field) => field.type !== 'geometry')
  }
  const selectedColumn = source && filteredColumns?.find((field) => field.name === column)

  return (
    <SelectField
      displayEmpty
      disabled={isDisabled || !filteredColumns?.length}
      label={labelId && <FormattedMessage id={labelId} />}
      labelId={`columns-${source}`}
      value={column}
      aria-label={`columns-${source}-selector`}
      onChange={(e) => {
        const column = filteredColumns?.find((field) => field.name === e.target.value)
        onChange(e.target.value as string, column?.type as string)
      }}
      renderValue={(selected) => {
        if (!selected) {
          return (
            <Typography variant="body2" color="text.hint">
              <FormattedMessage id={placeholderId} />
            </Typography>
          )
        }
        return <Typography variant="body2">{selectedColumn?.name}</Typography>
      }}
      data-testid={labelId}
    >
      {isOptional && column ? (
        <MenuItem value="">
          <FormattedMessage id="analysis.centroid.operatorNone" />
        </MenuItem>
      ) : null}
      {filteredColumns &&
        filteredColumns.map((field) => (
          <MenuItem key={field.name} value={field.name} aria-label={`column-${field.name}-dataset-${source}`}>
            <ListItemText>{field.name}</ListItemText>
            <TypeTag type={field.type} />
          </MenuItem>
        ))}
    </SelectField>
  )
}

export default ColumnsDropdown
